import { apply, put, takeLatest } from 'redux-saga/effects';

import { getSingleton } from '@occc-app/Activate/api';
import { MarketingContent as MarketingContentAPI } from '@occc-app/Activate/apiTypes';
import { ClientError } from '@occc-app/lib/client';
import { safeAsync } from '@occc-app/lib/safeAsync';
import { types as offerTypes, ActionCreators as OfferActionCreators } from '@occc-app/Offer/redux';

import actions from './actions';
import { deserializeMarketingContent } from './deserializers';

// Request Marketing Content
function* requestMarketingContent(action: ReturnType<OfferActionCreators['RequestOfferOK']>) {
  const core = getSingleton();
  const marketingContentId = action.marketingContents[0] && action.marketingContents[0].id;
  if (marketingContentId) {
    yield put(actions.requestMarketingContent(marketingContentId));

    const marketingContentsData = (yield apply(
      core,
      core.marketingContents.id(marketingContentId).show,
      [{}],
    )) as { data: MarketingContentAPI };

    const marketingContent = deserializeMarketingContent(marketingContentsData.data);
    yield put(actions.requestMarketingContentOK(marketingContent));
  }
  yield put(actions.requestMarketingContentsOK());
}

const sagas = {
  requestMarketingContent: safeAsync(requestMarketingContent, (error: ClientError, action) => {
    const errorMessages = error.errorMessages || [
      {
        message: `Unable to request marketing content: ${action.marketingContents}`,
      },
    ];
    return actions.requestMarketingContentERR(errorMessages, error);
  }),
};

export default function* saga() {
  yield takeLatest(offerTypes.REQUEST_OFFER_OK, sagas.requestMarketingContent);
}
